import { render, staticRenderFns } from "./editSaleAddonPrice.vue?vue&type=template&id=45aedf22&scoped=true"
import script from "./editSaleAddonPrice.vue?vue&type=script&lang=js"
export * from "./editSaleAddonPrice.vue?vue&type=script&lang=js"
import style0 from "./editSaleAddonPrice.vue?vue&type=style&index=0&id=45aedf22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aedf22",
  null
  
)

export default component.exports